import { rootApi } from '../rootApi';

export const claimLimitApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getClaimLimits: builder.query({
            query: ({ pageSize, pageNumber, responsibleName, productGroup, startDate, endDate }) => ({
                url: 'v1/claimlimit/getall',
                method: 'POST',
                body: {
                    PageSize: pageSize,
                    PageNumber: pageNumber,
                    ProductGroup: productGroup || undefined,
                    ResponsibleName: responsibleName || undefined,
                    StartDate: startDate || undefined,
                    EndDate: endDate || undefined
                }
            }),
            providesTags: ['ClaimLimit']
        }),
        createClaimLimit: builder.mutation({
            query: (data) => ({
                url: 'v1/claimlimit/create',
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['ClaimLimit']
        }),
        updateClaimLimit: builder.mutation({
            query: (data) => ({
                url: 'v1/claimlimit/update',
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['ClaimLimit']
        }),
        deleteClaimLimit: builder.mutation({
            query: (id) => ({
                url: `v1/claimlimit/delete`,
                method: 'POST',
                body: { id: id }
            }),
            invalidatesTags: ['ClaimLimit']
        })
    })
});

export const { useGetClaimLimitsQuery, useCreateClaimLimitMutation, useUpdateClaimLimitMutation, useDeleteClaimLimitMutation } = claimLimitApi;
